import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "sprout-ui-primitives";
import styled from "styled-components";
const UrlDisplayVideoWrapper = styled(Box)`
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
const UrlDisplayVideo = (props)=>{
    const { src , title  } = props;
    return /*#__PURE__*/ _jsx(UrlDisplayVideoWrapper, {
        paddingBottom: "56.25%",
        position: "relative",
        height: "0",
        children: /*#__PURE__*/ _jsx("iframe", {
            src: src,
            title: title,
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true
        })
    });
};
export default UrlDisplayVideo;
